import React from 'react';
import PropTypes from 'prop-types';

import DisplayPrice from '../../_utils/display-price';
import Pluralizer from '.././pluralizer';

const SubTotal = ({ quantity, subtotal, className }) => {
  return (
    <p
      className={`justify-content-between lead mx-0 my-1 ${className}`}
      data-test-id="subtotal">
      <span className="total-name">
        Subtotal{' '}
        <span
          className="quantity d-none d-sm-inline-block"
          data-test-id="item-count">
          (<Pluralizer count={quantity} singular="item" />)
        </span>
      </span>
      <span className="price" data-test-id="price">
        <DisplayPrice price={subtotal} />
      </span>
    </p>
  );
};

SubTotal.propTypes = {
  quantity: PropTypes.number.isRequired,
  subtotal: PropTypes.number.isRequired,
  className: PropTypes.string,
};

SubTotal.defaultProps = {
  className: 'd-flex',
};

export { SubTotal };
